import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { GenericValue, HisBackendService } from 'hisng';
import { ResearchContract } from 'app/fs/res/common/model/finance/research-contract-classes';

@Injectable()
export class ResearchContractService {

    private budgetPositionValues: GenericValue[];
    private researchFundTypeValues: GenericValue[];

    constructor( private backendService: HisBackendService ) {

        this.getBugdetPositions().subscribe( (budgetPositionValues: GenericValue[]) => {
            this.budgetPositionValues = budgetPositionValues;
        } );

        this.getRequestFundTypes().subscribe( (researchFundTypeValues: GenericValue[]) => {
            this.researchFundTypeValues = researchFundTypeValues;
        } );
    }

    /* get budgetPositionValues as array of GenericValues */
    public getBudgetPositionValues(): GenericValue[] {
        return this.budgetPositionValues;
    }

    /* get researchFundTypeValues as array of GenericValues */
    public getResearchFundTypeValues(): GenericValue[] {
        return this.researchFundTypeValues;
    }

    /* get bugdetPositions as Observable<GenericValue[]> */
    public getBugdetPositions(): Observable<GenericValue[]> {
        return this.backendService.getData( 'api/v1/fs/res/bugdetPositions' );
    }

    /* get researchFundTypes as Observable<GenericValue[]> */
    public getRequestFundTypes(): Observable<GenericValue[]> {
        return this.backendService.getData( 'api/v1/fs/res/requestFundTypes' );
    }

    public validateResearchContract( context: string, researchContract: ResearchContract ) {
        return this.backendService.postData( 'api/v1/fs/res/'+context+'/validateResearchContract', researchContract );
    }
}
